<template>
    <el-card shadow="hover">
        <label slot="header">类型输入框（继承el-input所有属性和插槽）</label>
        <el-divider content-position="left">默认所有文本</el-divider>
        <j-input v-model.trim="text" placeholder="所有文本" />
        <el-divider content-position="left">number：正负数，包括小数点（可输入多个负号和小数点，可能无法正常转number类型）</el-divider>
        <j-input type="number" v-model.trim="number" placeholder="正负数，包括小数点" />
        <el-divider content-position="left">negative：正负数，不包括小数点</el-divider>
        <j-input type="negative" v-model.number="negative" placeholder="正负数，不包括小数点" />
        <el-divider content-position="left">decimal：正数可包含两位小数位</el-divider>
        <j-input type="decimal" v-model.number="decimal" placeholder="正数可包含两位小数位" />
        <el-divider content-position="left">integer：正整数，不包括小数点</el-divider>
        <j-input type="integer" v-model.number="integer" placeholder="正整数，不包括小数点" />
        <el-divider content-position="left">number-letter：字母和数字</el-divider>
        <j-input type="number-letter" v-model.trim="numberLetter" placeholder="字母和数字" />
        <el-divider content-position="left">textarea：文本域（所有文本）</el-divider>
        <j-input type="textarea" v-model.trim="textarea" placeholder="文本域（所有文本）" />
        <el-divider content-position="left">password：加密框,设置:eye="false"，可关闭查看明文</el-divider>
        <j-input type="password" v-model.trim="password" placeholder="加密输入" />
    </el-card>
</template>

<script>
    import JInput from "./JInput";
    export default {
        components: {
            JInput
        },
        data() {
            return {
                text: '',
                number: '',
                integer: '',
                numberLetter: '',
                negative: '',
                decimal: '',
                textarea: '',
                password: ''
            }
        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>

</style>
